import UniformComponent from './UniformComponent';

export default UniformComponent;
